import type { InvitePayload } from '@/lib/startParam';

/**
 * IL REGISTRO DEI TIPI DI ATTERRAGGIO — dove un payload di `start_param`
 * diventa una rotta.
 *
 * ═══ PERCHE' VIVE QUI E NON IN `lib/logto.ts` ═══
 * (decisione or52 «deeplink-orc», 06/09) Il modulo di autenticazione e'
 * attraversato da OGNI login di OGNI utente. Se possedesse anche il registro
 * degli atterraggi, aggiungere un tipo nuovo — una scheda torneo, una news —
 * significherebbe mettere le mani nel punto piu' delicato della catena per una
 * ragione che con l'autenticazione non c'entra niente. Qui invece un tipo nuovo
 * e' una riga in questo file e nient'altro.
 *
 * ═══ LA REGOLA DI FORMA, RATIFICATA ═══
 * Il payload e' `<tipo>_<resto>`; si divide sul PRIMO `_` soltanto, e il resto
 * e' OPACO al dispatcher — chi smista non interpreta il carico.
 * ⚠️ E' anche la ragione per cui il prefisso e' `inv_bg_` e non `bg_`: il primo
 * segmento e' l'unica cosa che il dispatcher legge, e mettendoci il GIOCO il
 * registro dei tipi diventerebbe un registro dei giochi — dove una news o una
 * scheda torneo non potrebbero mai entrare.
 *
 * ⛔ NON coniare tipi in anticipo. Un tipo si conia quando ha un consumatore
 * vero: un prefisso inventato «per dopo» e' un vincolo che nessuno rinegozia,
 * perche' quando servira' sembrera' gia' deciso.
 */

/**
 * La rotta su cui portare l'utente per questo payload, o `null` se non c'e'
 * niente da fare.
 *
 * Pura di proposito: non naviga, non tocca lo storage, non guarda l'ora. Chi la
 * chiama decide QUANDO; questo file decide solo DOVE.
 */
export function routeForStartParam(payload: InvitePayload): string | null {
  switch (payload.kind) {
    case 'invite':
      // `/invito/<codice>` e non `/backgammon/match/<id>`: non esiste un match a
      // cui puntare — l'invito e' un bearer e il match lo crea l'accettazione.
      return `/invito/${payload.code}`;
    default:
      return null;
  }
}

/** Il prefisso di rotta che `usePendingInvite` usa per non rimbalzare su se stesso. */
export const INVITE_ROUTE_PREFIX = '/invito/';
